export default "__VITE_ASSET__DW2S$stj__"